import React, { useEffect, useState } from "react";
import { API_ciudadanos } from "../../config/apiConfig";
import { toast } from "react-toastify";
import { FaPenToSquare, FaRegTrashCan, FaCheck, FaX } from "react-icons/fa6";
import "../../pages/user/css/Curriculum.css";

const Idiomas = ({ usuario }) => {

  const idiomasDisponibles = [
    "Castellano", "Inglés", "Francés", "Chino", "Portugués", "Árabe", "Ruso", "Japonés",
  ];

  // Estado para almacenar los idiomas agregados
  const [idiomas, setIdiomas] = useState([]);
  // Estado para agregar un nuevo idioma
  const [nuevoIdioma, setNuevoIdioma] = useState("");
  const [nuevoNivel, setNuevoNivel] = useState("A1");
  // Estado para la edición
  const [editIndex, setEditIndex] = useState(null);
  const [editIdioma, setEditIdioma] = useState("");
  const [editNivel, setEditNivel] = useState("A1");

  useEffect(() => {
    if (usuario?.userId) {
      fetch(`${API_ciudadanos}/${usuario.userId}/curriculum`)
        .then((res) => res.json())
        .then((data) => {
          if (data?.LanguagesProficiency) {
            const idiomasTransformados = data.LanguagesProficiency.map((idioma) => ({
              idioma: idioma.languageName,
              nivel: idioma.cefrLevel.charAt(0).toUpperCase() + idioma.cefrLevel.slice(1) // Capitalizar
            }));
            setIdiomas(idiomasTransformados);
          }
        })
        .catch((err) => console.error("Error al cargar idiomas:", err));
    }
  }, [usuario]);
  

  const enviarIdiomasActualizados = async (idiomasFinales) => {
    const payload = {
      LanguagesProficiency: idiomasFinales.map((item) => ({
        languageName: item.idioma,
        cefrLevel: item.nivel.toLowerCase(), // Enviar en minúsculas
      })),
    };

    try {
      const res = await fetch(`${API_ciudadanos}/${usuario.userId}/curriculum`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      });

      if (!res.ok) throw new Error("Error al actualizar idiomas");
      toast.success("Idioma actualizado");
    } catch (error) {
      console.error("❌ Error al actualizar idiomas:", error);
      toast.error("No se pudieron guardar los cambios de idiomas");
    }
  };

  const handleAddIdioma = () => {
    if (nuevoIdioma && !idiomas.some((item) => item.idioma === nuevoIdioma)) {
      const actualizados = [...idiomas, { idioma: nuevoIdioma, nivel: nuevoNivel }];
      setIdiomas(actualizados);
      setNuevoIdioma("");
      setNuevoNivel("A1");
      enviarIdiomasActualizados(actualizados);
    }
  };

  const handleEditIdioma = (index) => {
    setEditIndex(index);
    setEditIdioma(idiomas[index].idioma);
    setEditNivel(idiomas[index].nivel);
  };

  const handleSaveEdit = () => {
    const updatedIdiomas = [...idiomas];
    updatedIdiomas[editIndex] = { idioma: editIdioma, nivel: editNivel };
    setIdiomas(updatedIdiomas);
    setEditIndex(null);
    enviarIdiomasActualizados(updatedIdiomas);
  };
  const handleCancelEdit = () => {
    setEditIndex(null);
  };

  // Eliminar idioma
  const handleDeleteIdioma = (index) => {
    const updatedIdiomas = idiomas.filter((_, i) => i !== index);
    setIdiomas(updatedIdiomas);
    enviarIdiomasActualizados(updatedIdiomas);
  };
  

  return (
   
    <div className="idiomas caja-verde">
        <h2 className="blanco fondo-verde mayusculas">IDIOMAS</h2>
        
        <div className="header between">
          <span className="idioma verde bold">IDIOMA</span>
          <span className="nivel verde bold">NIVEL</span>
          <span className="acciones"></span>
        </div>

        <ul className="contenido">
        {idiomas.length > 0 ? (
          idiomas.map((item, index) => (
          <li key={index} className="row between">
            {editIndex === index ? (
              <>
                {/* Selección de idioma en modo edición */}
                <select className="idioma" value={editIdioma} onChange={(e) => setEditIdioma(e.target.value)} aria-label="Idioma">
                  {idiomasDisponibles.map((opcion) => (
                    <option key={opcion} value={opcion}>{opcion}</option>
                  ))}
                </select>

                {/* Selección de nivel en modo edición */}
                <select className="nivel" value={editNivel} onChange={(e) => setEditNivel(e.target.value)} aria-label="Nivel">
                  <option value="A1">A1</option>
                  <option value="A2">A2</option>
                  <option value="B1">B1</option>
                  <option value="B2">B2</option>
                  <option value="C1">C1</option>
                  <option value="C2">C2</option>
                  <option value="Nativo">Nativo</option>
                </select>

                {/* Botón de Guardar edición */}
                <div className="check flex gap-5">
                  <button aria-label="Guardar cambios" className="fondo-blanco verde" onClick={handleSaveEdit}><FaCheck /></button>
                  <button aria-label="Cancelar cambios" className="fondo-blanco rojo" onClick={handleCancelEdit}><FaX /></button>
                </div>
              </>
            ) : (
              <>
                <span className="idioma">{item.idioma}</span>
                <span className="nivel">{item.nivel}</span>
                <div className="editar-cv botones-acciones flex gap-5">
                  <button aria-label="Cambiar el idioma o nivel" className="fondo-blanco" onClick={() => handleEditIdioma(index)}><FaPenToSquare /></button>
                  <button aria-label="Eliminar este nivel" className="fondo-blanco eliminar" onClick={() => handleDeleteIdioma(index)}><FaRegTrashCan /></button>
                </div>
              </>
            )}
          </li>
        ))
      ) : (
        <li className="texto-defecto">Selecciona los idiomas que sepas y tu nivel</li>
      )}
      </ul>

      {/* Agregar nuevo idioma */}
      <div className="nueva-edicion-rapida between gap-10 w-100">
        <select className="idioma" value={nuevoIdioma} onChange={(e) => setNuevoIdioma(e.target.value)} aria-label="Nuevo idioma">
          <option value="" disabled>Idioma</option>
          {idiomasDisponibles
            .filter((op) => !idiomas.some((item) => item.idioma === op)) // Evita duplicados
            .map((opcion) => (
              <option key={opcion} value={opcion}>{opcion}</option>
            ))}
        </select>

        <select className="nivel" value={nuevoNivel} onChange={(e) => setNuevoNivel(e.target.value)} aria-label="Nivel">
        <option value="A1">A1</option>
                  <option value="A2">A2</option>
                  <option value="B1">B1</option>
                  <option value="B2">B2</option>
                  <option value="C1">C1</option>
                  <option value="C2">C2</option>
                  <option value="Materno">Materno</option>
        </select>

        <button className="boton estrecho" onClick={handleAddIdioma}>Añadir</button>
      </div>
    </div>
                
  );
};

export default Idiomas;